module.exports = __webpack_public_path__ + "img/customers.06f21e03.jpg";